import { useCallback, useRef } from 'react';
import { useNoticeBannersStackContext } from '@sg/garnish';

import { type RouteInfo, useRouteObserver } from '../useRouteObserver';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Closes active notice banners when navigating away from the modal stack.
 */
export const useCloseNoticeBannersOnModalExit = () => {
  const { clear: closeActiveNoticeBanners } = useNoticeBannersStackContext();

  // ─── Refs ────────────────────────────────────────────────────────────

  const previousSegmentsRef = useRef<string[]>([]);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const closeBannersOnChange = useCallback(
    (route: RouteInfo) => {
      const previousSegments = previousSegmentsRef.current;
      const wasInModals = previousSegments[0] === MODALS_SEGMENT;
      const isInModals = route.segments[0] === MODALS_SEGMENT;

      previousSegmentsRef.current = route.segments;

      if (!wasInModals || isInModals) return;

      closeActiveNoticeBanners();
    },
    [closeActiveNoticeBanners],
  );

  // ─── Effects ─────────────────────────────────────────────────────────

  useRouteObserver({ onChange: closeBannersOnChange });
};

// ─── Constants ──────────────────────────────────────────────────────────────

const MODALS_SEGMENT = '(modals)';
